import styled from 'styled-components';
import { Slider as BPSlider } from '@blueprintjs/core';
export var StyledSlider = styled(BPSlider).withConfig({
  displayName: "Sliderstyles__StyledSlider",
  componentId: "sc-4rmdex-0"
})([""]);